import { useMemo, useState } from "react";

import { FileItem } from "@/common/fileItem";

export interface UseImageComparisonStateParams {
  beforeImages: FileItem[];
  afterImages: FileItem[];
  defaultBeforeSelectedId?: string;
  defaultAfterSelectedId?: string;
  /** [0, 1]. */
}

export function useImageComparisonState({
  beforeImages,
  afterImages,
  defaultBeforeSelectedId,
  defaultAfterSelectedId,
}: UseImageComparisonStateParams) {
  const [beforeSelectedId, setBeforeSelectedId] = useState<string | undefined>(
    defaultBeforeSelectedId || beforeImages[0]?.id,
  );
  const [afterSelectedId, setAfterSelectedId] = useState<string | undefined>(
    defaultAfterSelectedId || afterImages[0]?.id,
  );
  const [isShowLabels, setIsShowLabels] = useState(true);
  const [isSwapped, setIsSwapped] = useState(false);

  const beforeSelected = useMemo(
    () => beforeImages.find((x) => x.id === beforeSelectedId) || beforeImages[0],
    [beforeImages, beforeSelectedId],
  );
  const afterSelected = useMemo(
    () => afterImages.find((x) => x.id === afterSelectedId) || afterImages[0],
    [afterImages, afterSelectedId],
  );

  return {
    beforeSelected,
    afterSelected,
    beforeSelectedId,
    afterSelectedId,
    setBeforeSelectedId,
    setAfterSelectedId,
    isShowLabels,
    setIsShowLabels,
    isSwapped,
    setIsSwapped,
  };
}
